/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonNameInfo,
  PersonNameInfoOptional,
  PersonNameInfoMetaI,
  PersonNameInfoTrackedI,
} from "./person-name-info";
import { PersonNameInfoTracked, PersonNameInfoMeta } from "./person-name-info";

/**
 *
 * @export
 * @interface PersonSearchCriteria
 */
export interface PersonSearchCriteriaOptional extends PersonNameInfoOptional {
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  prefix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  first?: string;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  middle?: string;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  last?: string;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  suffix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  preferred?: string;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  organization?: string;
  /**
   *
   * @type {number}
   * @memberof PersonSearchCriteria
   */
  page?: number;
  /**
   *
   * @type {number}
   * @memberof PersonSearchCriteria
   */
  perPage?: number;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  cardNumber?: string;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  phone?: string;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  email?: string;
}

export interface PersonSearchCriteria
  extends PersonSearchCriteriaOptional, PersonNameInfo {
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  prefix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  first?: string;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  middle?: string;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  last?: string;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  suffix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  preferred?: string;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  organization?: string;
  /**
   *
   * @type {number}
   * @memberof PersonSearchCriteria
   */
  page?: number;
  /**
   *
   * @type {number}
   * @memberof PersonSearchCriteria
   */
  perPage?: number;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  cardNumber?: string;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  phone?: string;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  email?: string;
}

export interface PersonSearchCriteriaTrackedI extends PersonNameInfoOptional {
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  prefix?: string;
  prefixIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  first?: string;
  firstIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  middle?: string;
  middleIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  last?: string;
  lastIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  suffix?: string;
  suffixIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  preferred?: string;
  preferredIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  organization?: string;
  organizationIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PersonSearchCriteria
   */
  page?: number;
  pageIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PersonSearchCriteria
   */
  perPage?: number;
  perPageIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  cardNumber?: string;
  cardNumberIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  phone?: string;
  phoneIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonSearchCriteria
   */
  email?: string;
  emailIsSet: boolean;
}

transformDatesMap.set(
  "PersonSearchCriteria",
  function (model: PersonSearchCriteria) {},
);

export type PersonSearchCriteriaMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  prefix: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  first: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  middle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  last: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  suffix: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  preferred: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  organization: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  page: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  perPage: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  cardNumber: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  phone: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  email: PropertyMeta<MetaTypeBase<string>>;
}>;

export var PersonSearchCriteriaMeta: PersonSearchCriteriaMetaI =
  {} as PersonSearchCriteriaMetaI;
PersonSearchCriteriaMeta = typeMeta("PersonSearchCriteria", {
  prefix: propertyMeta("prefix", false, false, false, MetaTypesBase.string),
  first: propertyMeta("first", false, false, false, MetaTypesBase.string),
  middle: propertyMeta("middle", false, false, false, MetaTypesBase.string),
  last: propertyMeta("last", false, false, false, MetaTypesBase.string),
  suffix: propertyMeta("suffix", false, false, false, MetaTypesBase.string),
  preferred: propertyMeta(
    "preferred",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  organization: propertyMeta(
    "organization",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  page: propertyMeta("page", false, false, false, MetaTypesBase.number),
  perPage: propertyMeta("perPage", false, false, false, MetaTypesBase.number),
  cardNumber: propertyMeta(
    "cardNumber",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  phone: propertyMeta("phone", false, false, false, MetaTypesBase.string),
  email: propertyMeta("email", false, false, false, MetaTypesBase.string),
});

const metaI = PersonSearchCriteriaMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PersonNameInfoMeta]);
  metaI.prefix.inheritedFrom = PersonNameInfoMeta.prefix;
  metaI.first.inheritedFrom = PersonNameInfoMeta.first;
  metaI.middle.inheritedFrom = PersonNameInfoMeta.middle;
  metaI.last.inheritedFrom = PersonNameInfoMeta.last;
  metaI.suffix.inheritedFrom = PersonNameInfoMeta.suffix;
  metaI.preferred.inheritedFrom = PersonNameInfoMeta.preferred;
  metaI.organization.inheritedFrom = PersonNameInfoMeta.organization;
});

export class PersonSearchCriteriaTracked
  extends PersonNameInfoTracked
  implements PersonSearchCriteriaTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  prefix__I?: string = undefined;
  prefixIsSet: boolean = false;
  set prefix(v: undefined | string) {
    if (v !== undefined) {
      this.prefix__I = v;
      this.prefixIsSet = true;
    } else {
      this.prefix__I = v || undefined;
      this.prefixIsSet = false;
    }
    this.changeTracker = true;
  }
  get prefix() {
    return this.prefix__I;
  }
  first__I?: string = undefined;
  firstIsSet: boolean = false;
  set first(v: undefined | string) {
    if (v !== undefined) {
      this.first__I = v;
      this.firstIsSet = true;
    } else {
      this.first__I = v || undefined;
      this.firstIsSet = false;
    }
    this.changeTracker = true;
  }
  get first() {
    return this.first__I;
  }
  middle__I?: string = undefined;
  middleIsSet: boolean = false;
  set middle(v: undefined | string) {
    if (v !== undefined) {
      this.middle__I = v;
      this.middleIsSet = true;
    } else {
      this.middle__I = v || undefined;
      this.middleIsSet = false;
    }
    this.changeTracker = true;
  }
  get middle() {
    return this.middle__I;
  }
  last__I?: string = undefined;
  lastIsSet: boolean = false;
  set last(v: undefined | string) {
    if (v !== undefined) {
      this.last__I = v;
      this.lastIsSet = true;
    } else {
      this.last__I = v || undefined;
      this.lastIsSet = false;
    }
    this.changeTracker = true;
  }
  get last() {
    return this.last__I;
  }
  suffix__I?: string = undefined;
  suffixIsSet: boolean = false;
  set suffix(v: undefined | string) {
    if (v !== undefined) {
      this.suffix__I = v;
      this.suffixIsSet = true;
    } else {
      this.suffix__I = v || undefined;
      this.suffixIsSet = false;
    }
    this.changeTracker = true;
  }
  get suffix() {
    return this.suffix__I;
  }
  preferred__I?: string = undefined;
  preferredIsSet: boolean = false;
  set preferred(v: undefined | string) {
    if (v !== undefined) {
      this.preferred__I = v;
      this.preferredIsSet = true;
    } else {
      this.preferred__I = v || undefined;
      this.preferredIsSet = false;
    }
    this.changeTracker = true;
  }
  get preferred() {
    return this.preferred__I;
  }
  organization__I?: string = undefined;
  organizationIsSet: boolean = false;
  set organization(v: undefined | string) {
    if (v !== undefined) {
      this.organization__I = v;
      this.organizationIsSet = true;
    } else {
      this.organization__I = v || undefined;
      this.organizationIsSet = false;
    }
    this.changeTracker = true;
  }
  get organization() {
    return this.organization__I;
  }
  page__I?: number = undefined;
  pageIsSet: boolean = false;
  set page(v: undefined | number) {
    if (v !== undefined) {
      this.page__I = v;
      this.pageIsSet = true;
    } else {
      this.page__I = v || undefined;
      this.pageIsSet = false;
    }
    this.changeTracker = true;
  }
  get page() {
    return this.page__I;
  }
  perPage__I?: number = undefined;
  perPageIsSet: boolean = false;
  set perPage(v: undefined | number) {
    if (v !== undefined) {
      this.perPage__I = v;
      this.perPageIsSet = true;
    } else {
      this.perPage__I = v || undefined;
      this.perPageIsSet = false;
    }
    this.changeTracker = true;
  }
  get perPage() {
    return this.perPage__I;
  }
  cardNumber__I?: string = undefined;
  cardNumberIsSet: boolean = false;
  set cardNumber(v: undefined | string) {
    if (v !== undefined) {
      this.cardNumber__I = v;
      this.cardNumberIsSet = true;
    } else {
      this.cardNumber__I = v || undefined;
      this.cardNumberIsSet = false;
    }
    this.changeTracker = true;
  }
  get cardNumber() {
    return this.cardNumber__I;
  }
  phone__I?: string = undefined;
  phoneIsSet: boolean = false;
  set phone(v: undefined | string) {
    if (v !== undefined) {
      this.phone__I = v;
      this.phoneIsSet = true;
    } else {
      this.phone__I = v || undefined;
      this.phoneIsSet = false;
    }
    this.changeTracker = true;
  }
  get phone() {
    return this.phone__I;
  }
  email__I?: string = undefined;
  emailIsSet: boolean = false;
  set email(v: undefined | string) {
    if (v !== undefined) {
      this.email__I = v;
      this.emailIsSet = true;
    } else {
      this.email__I = v || undefined;
      this.emailIsSet = false;
    }
    this.changeTracker = true;
  }
  get email() {
    return this.email__I;
  }
  constructor(config?: PersonSearchCriteriaOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: PersonSearchCriteriaOptional,
    options?: AssignOptions,
  ): PersonSearchCriteriaTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.prefix && this.prefixApplyFilter(optionsRequired.filter)) {
      this.prefix = config.prefix;
      if (optionsRequired.unassign) this.prefixIsSet = false;
      else this.prefixIsSet = true;
    }
    if (config.first && this.firstApplyFilter(optionsRequired.filter)) {
      this.first = config.first;
      if (optionsRequired.unassign) this.firstIsSet = false;
      else this.firstIsSet = true;
    }
    if (config.middle && this.middleApplyFilter(optionsRequired.filter)) {
      this.middle = config.middle;
      if (optionsRequired.unassign) this.middleIsSet = false;
      else this.middleIsSet = true;
    }
    if (config.last && this.lastApplyFilter(optionsRequired.filter)) {
      this.last = config.last;
      if (optionsRequired.unassign) this.lastIsSet = false;
      else this.lastIsSet = true;
    }
    if (config.suffix && this.suffixApplyFilter(optionsRequired.filter)) {
      this.suffix = config.suffix;
      if (optionsRequired.unassign) this.suffixIsSet = false;
      else this.suffixIsSet = true;
    }
    if (config.preferred && this.preferredApplyFilter(optionsRequired.filter)) {
      this.preferred = config.preferred;
      if (optionsRequired.unassign) this.preferredIsSet = false;
      else this.preferredIsSet = true;
    }
    if (
      config.organization &&
      this.organizationApplyFilter(optionsRequired.filter)
    ) {
      this.organization = config.organization;
      if (optionsRequired.unassign) this.organizationIsSet = false;
      else this.organizationIsSet = true;
    }
    if (config.page && this.pageApplyFilter(optionsRequired.filter)) {
      this.page = config.page;
      if (optionsRequired.unassign) this.pageIsSet = false;
      else this.pageIsSet = true;
    }
    if (config.perPage && this.perPageApplyFilter(optionsRequired.filter)) {
      this.perPage = config.perPage;
      if (optionsRequired.unassign) this.perPageIsSet = false;
      else this.perPageIsSet = true;
    }
    if (
      config.cardNumber &&
      this.cardNumberApplyFilter(optionsRequired.filter)
    ) {
      this.cardNumber = config.cardNumber;
      if (optionsRequired.unassign) this.cardNumberIsSet = false;
      else this.cardNumberIsSet = true;
    }
    if (config.phone && this.phoneApplyFilter(optionsRequired.filter)) {
      this.phone = config.phone;
      if (optionsRequired.unassign) this.phoneIsSet = false;
      else this.phoneIsSet = true;
    }
    if (config.email && this.emailApplyFilter(optionsRequired.filter)) {
      this.email = config.email;
      if (optionsRequired.unassign) this.emailIsSet = false;
      else this.emailIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonSearchCriteriaTrackedI {
    const cloned = {} as PersonSearchCriteriaTrackedI;
    if (
      this.prefixIsSetDeep() &&
      this.prefixApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.prefixIsSet = true;
      cloned.prefix = this.prefix;
    } else {
      //cloned.prefixIsSet = false
    }
    if (
      this.firstIsSetDeep() &&
      this.firstApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.firstIsSet = true;
      cloned.first = this.first;
    } else {
      //cloned.firstIsSet = false
    }
    if (
      this.middleIsSetDeep() &&
      this.middleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.middleIsSet = true;
      cloned.middle = this.middle;
    } else {
      //cloned.middleIsSet = false
    }
    if (
      this.lastIsSetDeep() &&
      this.lastApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.lastIsSet = true;
      cloned.last = this.last;
    } else {
      //cloned.lastIsSet = false
    }
    if (
      this.suffixIsSetDeep() &&
      this.suffixApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.suffixIsSet = true;
      cloned.suffix = this.suffix;
    } else {
      //cloned.suffixIsSet = false
    }
    if (
      this.preferredIsSetDeep() &&
      this.preferredApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.preferredIsSet = true;
      cloned.preferred = this.preferred;
    } else {
      //cloned.preferredIsSet = false
    }
    if (
      this.organizationIsSetDeep() &&
      this.organizationApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.organizationIsSet = true;
      cloned.organization = this.organization;
    } else {
      //cloned.organizationIsSet = false
    }
    if (
      this.pageIsSetDeep() &&
      this.pageApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.pageIsSet = true;
      cloned.page = this.page;
    } else {
      //cloned.pageIsSet = false
    }
    if (
      this.perPageIsSetDeep() &&
      this.perPageApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.perPageIsSet = true;
      cloned.perPage = this.perPage;
    } else {
      //cloned.perPageIsSet = false
    }
    if (
      this.cardNumberIsSetDeep() &&
      this.cardNumberApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cardNumberIsSet = true;
      cloned.cardNumber = this.cardNumber;
    } else {
      //cloned.cardNumberIsSet = false
    }
    if (
      this.phoneIsSetDeep() &&
      this.phoneApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.phoneIsSet = true;
      cloned.phone = this.phone;
    } else {
      //cloned.phoneIsSet = false
    }
    if (
      this.emailIsSetDeep() &&
      this.emailApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emailIsSet = true;
      cloned.email = this.email;
    } else {
      //cloned.emailIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonSearchCriteriaTrackedI {
    if (!this.prefixApplyFilter(filter)) this.prefixIsSet = false;

    if (!this.firstApplyFilter(filter)) this.firstIsSet = false;

    if (!this.middleApplyFilter(filter)) this.middleIsSet = false;

    if (!this.lastApplyFilter(filter)) this.lastIsSet = false;

    if (!this.suffixApplyFilter(filter)) this.suffixIsSet = false;

    if (!this.preferredApplyFilter(filter)) this.preferredIsSet = false;

    if (!this.organizationApplyFilter(filter)) this.organizationIsSet = false;

    if (!this.pageApplyFilter(filter)) this.pageIsSet = false;

    if (!this.perPageApplyFilter(filter)) this.perPageIsSet = false;

    if (!this.cardNumberApplyFilter(filter)) this.cardNumberIsSet = false;

    if (!this.phoneApplyFilter(filter)) this.phoneIsSet = false;

    if (!this.emailApplyFilter(filter)) this.emailIsSet = false;

    return this;
  }
  prefixApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSearchCriteriaMeta.prefix,
      PersonSearchCriteriaMeta,
      this.prefix,
      this,
    );
  }
  prefixIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.prefixIsSet && this.prefixApplyFilter(filter)) return true;

    return false;
  }
  firstApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSearchCriteriaMeta.first,
      PersonSearchCriteriaMeta,
      this.first,
      this,
    );
  }
  firstIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.firstIsSet && this.firstApplyFilter(filter)) return true;

    return false;
  }
  middleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSearchCriteriaMeta.middle,
      PersonSearchCriteriaMeta,
      this.middle,
      this,
    );
  }
  middleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.middleIsSet && this.middleApplyFilter(filter)) return true;

    return false;
  }
  lastApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSearchCriteriaMeta.last,
      PersonSearchCriteriaMeta,
      this.last,
      this,
    );
  }
  lastIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.lastIsSet && this.lastApplyFilter(filter)) return true;

    return false;
  }
  suffixApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSearchCriteriaMeta.suffix,
      PersonSearchCriteriaMeta,
      this.suffix,
      this,
    );
  }
  suffixIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.suffixIsSet && this.suffixApplyFilter(filter)) return true;

    return false;
  }
  preferredApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSearchCriteriaMeta.preferred,
      PersonSearchCriteriaMeta,
      this.preferred,
      this,
    );
  }
  preferredIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.preferredIsSet && this.preferredApplyFilter(filter)) return true;

    return false;
  }
  organizationApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSearchCriteriaMeta.organization,
      PersonSearchCriteriaMeta,
      this.organization,
      this,
    );
  }
  organizationIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.organizationIsSet && this.organizationApplyFilter(filter))
      return true;

    return false;
  }
  pageApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSearchCriteriaMeta.page,
      PersonSearchCriteriaMeta,
      this.page,
      this,
    );
  }
  pageIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.pageIsSet && this.pageApplyFilter(filter)) return true;

    return false;
  }
  perPageApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSearchCriteriaMeta.perPage,
      PersonSearchCriteriaMeta,
      this.perPage,
      this,
    );
  }
  perPageIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.perPageIsSet && this.perPageApplyFilter(filter)) return true;

    return false;
  }
  cardNumberApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSearchCriteriaMeta.cardNumber,
      PersonSearchCriteriaMeta,
      this.cardNumber,
      this,
    );
  }
  cardNumberIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.cardNumberIsSet && this.cardNumberApplyFilter(filter)) return true;

    return false;
  }
  phoneApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSearchCriteriaMeta.phone,
      PersonSearchCriteriaMeta,
      this.phone,
      this,
    );
  }
  phoneIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.phoneIsSet && this.phoneApplyFilter(filter)) return true;

    return false;
  }
  emailApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSearchCriteriaMeta.email,
      PersonSearchCriteriaMeta,
      this.email,
      this,
    );
  }
  emailIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.emailIsSet && this.emailApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.prefixIsSetDeep(filter)) return true;
    if (this.firstIsSetDeep(filter)) return true;
    if (this.middleIsSetDeep(filter)) return true;
    if (this.lastIsSetDeep(filter)) return true;
    if (this.suffixIsSetDeep(filter)) return true;
    if (this.preferredIsSetDeep(filter)) return true;
    if (this.organizationIsSetDeep(filter)) return true;
    if (this.pageIsSetDeep(filter)) return true;
    if (this.perPageIsSetDeep(filter)) return true;
    if (this.cardNumberIsSetDeep(filter)) return true;
    if (this.phoneIsSetDeep(filter)) return true;
    if (this.emailIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
